module.exports = __webpack_public_path__ + "static/img/topBackground.24683297.jpg";